export default __webpack_public_path__ + "static/media/bg13.629b9341.svg";